// extracted by mini-css-extract-plugin
module.exports = {"container":"Section_Price_container__2ZJx6","content":"Section_Price_content__usVZK","p":"Section_Price_p__DHKTN","cards":"Section_Price_cards__1KYzI"};